const scroller = document.querySelector('.review__cards');
const cards = document.querySelectorAll('.review__card');

const dots = document.querySelector('.review__dots');
let dotItems = document.querySelectorAll('.review__dot');

const buttonLeft = document.querySelector('.review__button.left');
const buttonRight = document.querySelector('.review__button.right');

const breakpointMD = 679;
const breakpointLG = 1299;

let index = 0;
let dotIndex = 0;
let limit = 0;
let offset = 0;

updateLimit();

window.addEventListener("resize", () => updateLimit());

// if(cards && dots) {
//   cards.forEach(card => {
//     const dot = document.createElement('div');
//     dot.classList.add('review__dot');
//     dots.appendChild(dot)
//   });

//   dotItems = document.querySelectorAll('.review__dot');
//   dotItems[0].classList.add('active');
// }

buttonLeft.addEventListener('click', () => {
  index--;
  buttonRight.disabled = false;

  if(index == 0) buttonLeft.disabled = true;

  updateScroller(-1);
})

buttonRight.addEventListener('click', () => {
  index++;
  buttonLeft.disabled = false;

  if(index == limit - 1) buttonRight.disabled = true;

  updateScroller(+1);
})

function updateScroller(direction) {
  scroller.style.setProperty('--translation-modifier', index);
  updateDots(direction);
}

function updateDots(direction) {
  dotIndex += offset * direction;
  
  if(dotIndex < 0) dotIndex = 0;
  if(dotIndex > cards.length - 1) dotIndex = cards.length - 1;
  
  dotItems.forEach(dot => dot.classList.remove('active'));
  dotItems[dotIndex].classList.add('active');
}

function updateLimit() {
  const currentSize = scroller.clientWidth;

  if(currentSize < breakpointMD) {
    limit = cards.length;
    offset = 1;
  }else if (currentSize < breakpointLG) {
    limit = Math.ceil(cards.length / 2);
    offset = 2;
  }else {
    limit = Math.ceil(cards.length / 3);
    offset = 3;
  }

  console.log(limit);
}